export const isValidData = (formData: Record<string, any>): boolean => {
    return Object.values(formData).some(value => value !== "");
};
